module.exports = __webpack_public_path__ + "static/media/ah-screen-3.5d0aa222.png";